import { schema as personIdDocumentSchema } from 'shared/components/(wallets)/kyc/PersonIdDocument/PersonIdDocument.schema';

export const schema = personIdDocumentSchema.passthrough();
